export class County {
    key! : string;
    name! : string;
    region! : string;
    country_code! : string;
    type! : string;
}